// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditStripsPopup-module__font-s-10___Y97R0 {
  font-size: 10px !important;
}

.EditStripsPopup-module__font-s-12___fTesY {
  font-size: 12px !important;
}

.EditStripsPopup-module__font-s-13___cYsI0 {
  font-size: 13px !important;
}

.EditStripsPopup-module__font-s-14___s1iqn {
  font-size: 14px !important;
}

.EditStripsPopup-module__font-s-15___L3_9m {
  font-size: 15px !important;
}

.EditStripsPopup-module__font-s-16___INQCu {
  font-size: 16px !important;
}

.EditStripsPopup-module__font-s-18___uM_R2 {
  font-size: 18px !important;
}

.EditStripsPopup-module__font-s-20___xycTO {
  font-size: 20px !important;
}

.EditStripsPopup-module__font-s-22___fgh5A {
  font-size: 22px !important;
}

.EditStripsPopup-module__font-s-28___tFyKd {
  font-size: 28px !important;
}

.EditStripsPopup-module__font-w-400___GjqZ2 {
  font-weight: 400 !important;
}

.EditStripsPopup-module__font-w-500___N4f53 {
  font-weight: 500 !important;
}

.EditStripsPopup-module__font-w-600___jhCvM {
  font-weight: 600 !important;
}

.EditStripsPopup-module__font-w-700___fkQJG {
  font-weight: 700 !important;
}

.EditStripsPopup-module__p-5___kRdAx {
  padding: 5px !important;
}

.EditStripsPopup-module__p-12___ifLzp {
  padding: 12px !important;
}

.EditStripsPopup-module__p-16___PXM4V {
  padding: 16px !important;
}

.EditStripsPopup-module__p-30___Mh0Ja {
  padding: 30px !important;
}

.EditStripsPopup-module__p-b-0___JvKTV {
  padding-bottom: 0 !important;
}

.EditStripsPopup-module__p-b-5___l4cf5 {
  padding-bottom: 5px !important;
}

.EditStripsPopup-module__p-b-10___tz1Jb {
  padding-bottom: 10px !important;
}

.EditStripsPopup-module__p-b-12___uYhba {
  padding-bottom: 12px !important;
}

.EditStripsPopup-module__p-b-16___zeyHl {
  padding-bottom: 16px !important;
}

.EditStripsPopup-module__p-b-18___bmisQ {
  padding-bottom: 18px !important;
}

.EditStripsPopup-module__p-b-20___ZySWv {
  padding-bottom: 20px !important;
}

.EditStripsPopup-module__p-b-25___OmDyk {
  padding-bottom: 25px !important;
}

.EditStripsPopup-module__p-b-30___rKdhr {
  padding-bottom: 30px !important;
}

.EditStripsPopup-module__p-b-50___tC2WV {
  padding-bottom: 50px !important;
}

.EditStripsPopup-module__p-t-0___jqF19 {
  padding-top: 0 !important;
}

.EditStripsPopup-module__p-t-12___auH_k {
  padding-top: 12px !important;
}

.EditStripsPopup-module__p-t-16___YV13i {
  padding-top: 16px !important;
}

.EditStripsPopup-module__p-t-18___ADhRx {
  padding-top: 18px !important;
}

.EditStripsPopup-module__p-t-20___aI2LY {
  padding-top: 20px !important;
}

.EditStripsPopup-module__p-t-30___GwXdG {
  padding-top: 30px !important;
}

.EditStripsPopup-module__p-t-40___qoWXb {
  padding-top: 40px !important;
}

.EditStripsPopup-module__p-t-50___aNVpX {
  padding-top: 50px !important;
}

.EditStripsPopup-module__p-l-20___Atvdm {
  padding-left: 20px !important;
}

.EditStripsPopup-module__p-l-30___YFOZK {
  padding-left: 30px !important;
}

.EditStripsPopup-module__p-l-40___xkjiO {
  padding-left: 40px !important;
}

.EditStripsPopup-module__p-r-16___cR4j5 {
  padding-right: 16px !important;
}

.EditStripsPopup-module__p-r-20___b6dzT {
  padding-right: 20px !important;
}

.EditStripsPopup-module__p-r-30___CoZWk {
  padding-right: 30px !important;
}

.EditStripsPopup-module__p-r-50___als49 {
  padding-right: 50px !important;
}

.EditStripsPopup-module__p-r-60___KQxMY {
  padding-right: 60px !important;
}

.EditStripsPopup-module__m-b-1___ljCrE {
  margin-bottom: 1px !important;
}

.EditStripsPopup-module__m-b-2___YO6wO {
  margin-bottom: 2px !important;
}

.EditStripsPopup-module__m-b-6___l1k0x {
  margin-bottom: 6px !important;
}

.EditStripsPopup-module__m-b-8___rMZrJ {
  margin-bottom: 8px !important;
}

.EditStripsPopup-module__m-b-10___tp_fV {
  margin-bottom: 10px !important;
}

.EditStripsPopup-module__m-b-14___dIg7K {
  margin-bottom: 14px !important;
}

.EditStripsPopup-module__m-b-16___sYzlc {
  margin-bottom: 16px !important;
}

.EditStripsPopup-module__m-b-20___xvS_S {
  margin-bottom: 20px !important;
}

.EditStripsPopup-module__m-b-22____LxBv {
  margin-bottom: 22px !important;
}

.EditStripsPopup-module__m-b-24___Fpvx4 {
  margin-bottom: 24px !important;
}

.EditStripsPopup-module__m-b-30___WSk3j {
  margin-bottom: 30px !important;
}

.EditStripsPopup-module__m-b-32___rH9TZ {
  margin-bottom: 32px !important;
}

.EditStripsPopup-module__m-b-40___jLI84 {
  margin-bottom: 40px !important;
}

.EditStripsPopup-module__m-t-2___IY4cC {
  margin-top: 2px !important;
}

.EditStripsPopup-module__m-t-3___zVIuH {
  margin-top: 3px !important;
}

.EditStripsPopup-module__m-t-4___djm1j {
  margin-top: 4px !important;
}

.EditStripsPopup-module__m-t-5___gjQfG {
  margin-top: 5px !important;
}

.EditStripsPopup-module__m-t-8___zfggq {
  margin-top: 8px !important;
}

.EditStripsPopup-module__m-t-10___DFlFN {
  margin-top: 10px !important;
}

.EditStripsPopup-module__m-t-15___lgT0J {
  margin-top: 15px !important;
}

.EditStripsPopup-module__m-t-16___S7daC {
  margin-top: 16px !important;
}

.EditStripsPopup-module__m-t-20___R1Gw6 {
  margin-top: 20px !important;
}

.EditStripsPopup-module__m-t-22___HFLmg {
  margin-top: 22px !important;
}

.EditStripsPopup-module__m-t-30___irDCZ {
  margin-top: 30px !important;
}

.EditStripsPopup-module__m-t-32___kHxJM {
  margin-top: 32px !important;
}

.EditStripsPopup-module__m-l-auto___QldPu {
  margin-left: auto !important;
}

.EditStripsPopup-module__m-l-4____ogOk {
  margin-left: 4px !important;
}

.EditStripsPopup-module__m-l-5___y5yJd {
  margin-left: 5px !important;
}

.EditStripsPopup-module__m-l-6___NUGzv {
  margin-left: 6px !important;
}

.EditStripsPopup-module__m-l-8___HTHPs {
  margin-left: 8px !important;
}

.EditStripsPopup-module__m-l-10___NEhvm {
  margin-left: 10px !important;
}

.EditStripsPopup-module__m-l-16____AUZI {
  margin-left: 16px !important;
}

.EditStripsPopup-module__m-l-20___QBauV {
  margin-left: 20px !important;
}

.EditStripsPopup-module__m-l-24___pwNqp {
  margin-left: 24px !important;
}

.EditStripsPopup-module__m-l-30___X9x7z {
  margin-left: 30px !important;
}

.EditStripsPopup-module__m-l-35___u8HKS {
  margin-left: 35px !important;
}

.EditStripsPopup-module__m-l-40___qXHUR {
  margin-left: 40px !important;
}

.EditStripsPopup-module__m-r-8___VBzBo {
  margin-right: 8px !important;
}

.EditStripsPopup-module__m-r-10___t4pMm {
  margin-right: 10px !important;
}

.EditStripsPopup-module__m-r-16____Obi1 {
  margin-right: 16px !important;
}

.EditStripsPopup-module__m-r-20___rH2nP {
  margin-right: 20px !important;
}

.EditStripsPopup-module__m-r-24___BFrde {
  margin-right: 24px !important;
}

.EditStripsPopup-module__m-r-30___cspZ_ {
  margin-right: 30px !important;
}

.EditStripsPopup-module__m-r-40___rGiZ_ {
  margin-right: 40px !important;
}

.EditStripsPopup-module__border-r-3___vJDHI {
  border-radius: 3px !important;
}

.EditStripsPopup-module__border-r-4___S15eU {
  border-radius: 4px !important;
}

.EditStripsPopup-module__border-r-6___kPX_D {
  border-radius: 6px !important;
}

.EditStripsPopup-module__border-r-10___fZr10 {
  border-radius: 10px !important;
}

.EditStripsPopup-module__border-r-12___R8UOT {
  border-radius: 12px !important;
}

.EditStripsPopup-module__border-r-16___BgwE7 {
  border-radius: 16px !important;
}

.EditStripsPopup-module__border-r-50___IkGyt {
  border-radius: 50% !important;
}

.EditStripsPopup-module__primary-border___KgbgO {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.EditStripsPopup-module__primary-border-b___VD5qv {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.EditStripsPopup-module__primary-border-t___dbvMd {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.EditStripsPopup-module__primary-border-l___YrJiR {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.EditStripsPopup-module__primary-border-r___bdKpo {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.EditStripsPopup-module__secondary-border___O6XcN {
  border: 1px solid #637768;
}

.EditStripsPopup-module__secondary-border-b___zDGgv {
  border-bottom: 1px solid #637768;
}

.EditStripsPopup-module__secondary-border-t___xcFoh {
  border-top: 1px solid #637768;
}

.EditStripsPopup-module__secondary-border-l___COnH3 {
  border-left: 1px solid #637768;
}

.EditStripsPopup-module__secondary-border-r___HpCtD {
  border-right: 1px solid #637768;
}

.EditStripsPopup-module__gap-0___Dh4eT {
  gap: 0 !important;
}

.EditStripsPopup-module__gap-2___kFwR1 {
  gap: 2px !important;
}

.EditStripsPopup-module__gap-4___thHmJ {
  gap: 4px !important;
}

.EditStripsPopup-module__gap-5___OC9j1 {
  gap: 5px !important;
}

.EditStripsPopup-module__gap-6___qtNaa {
  gap: 6px !important;
}

.EditStripsPopup-module__gap-8___xQvfc {
  gap: 8px !important;
}

.EditStripsPopup-module__gap-10___dMjHj {
  gap: 10px !important;
}

.EditStripsPopup-module__gap-12___RTTXP {
  gap: 12px !important;
}

.EditStripsPopup-module__gap-14___MX9k3 {
  gap: 14px !important;
}

.EditStripsPopup-module__gap-16___glDQR {
  gap: 16px !important;
}

.EditStripsPopup-module__gap-18___JNI_7 {
  gap: 18px !important;
}

.EditStripsPopup-module__gap-20___tOt26 {
  gap: 20px !important;
}

.EditStripsPopup-module__gap-24___WxA61 {
  gap: 24px !important;
}

.EditStripsPopup-module__gap-26___jJBLX {
  gap: 26px !important;
}

.EditStripsPopup-module__gap-30___Vpb7i {
  gap: 30px !important;
}

.EditStripsPopup-module__gap-32___RWRva {
  gap: 32px !important;
}

.EditStripsPopup-module__gap-40___td9rT {
  gap: 40px !important;
}

.EditStripsPopup-module__gap-50___vhWk7 {
  gap: 50px !important;
}

.EditStripsPopup-module__flex-1___WQajw {
  flex: 1;
}

.EditStripsPopup-module__flex-none___v4xVh {
  flex: none !important;
}

.EditStripsPopup-module__flex-column___yKwP0 {
  display: flex;
  flex-direction: column !important;
}

.EditStripsPopup-module__flex-row___qYKLD {
  display: flex;
  flex-direction: row !important;
}

.EditStripsPopup-module__vertically-centered___RtIDm {
  display: flex;
  align-items: center !important;
}

.EditStripsPopup-module__horizontally-centered___vzWGI {
  display: flex;
  justify-content: center !important;
}

.EditStripsPopup-module__horizontally-end___SHI5d {
  display: flex;
  justify-content: end !important;
}

.EditStripsPopup-module__vertically-start___U4zYg {
  display: flex;
  align-items: start !important;
}

.EditStripsPopup-module__space-between___Jq0f6 {
  display: flex;
  justify-content: space-between !important;
}

.EditStripsPopup-module__flex-wrap___tOEZc {
  flex-wrap: wrap !important;
}

.EditStripsPopup-module__height-100___R5urd {
  height: 100%;
}

.EditStripsPopup-module__width-50___Iq30J {
  width: 50% !important;
}

.EditStripsPopup-module__width-100___C9qcb {
  width: 100%;
}

.EditStripsPopup-module__cursor-pointer___ey1iK {
  cursor: pointer;
}

.EditStripsPopup-module__cursor-not-allowed___KRjl4 {
  cursor: not-allowed !important;
}

.EditStripsPopup-module__absolute-centered___su2P_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.EditStripsPopup-module__absolute___N2TRm {
  position: absolute;
}

.EditStripsPopup-module__relative___Tcp7z {
  position: relative;
}

.EditStripsPopup-module__fixed___ZTxsX {
  position: fixed;
}

.EditStripsPopup-module__visible___vc571 {
  opacity: 1;
}

.EditStripsPopup-module__invisible___x2Pyb {
  opacity: 0;
}

.EditStripsPopup-module__col-90___wGuMA {
  width: 90% !important;
}

.EditStripsPopup-module__col-auto___AcmjY {
  width: auto !important;
}

.EditStripsPopup-module__medical-tabs___I8CNx {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.EditStripsPopup-module__medical-table-new___PR8F7 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.EditStripsPopup-module__medical-table-new___PR8F7:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.EditStripsPopup-module__medical-table-new___PR8F7::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.EditStripsPopup-module__medical-table-new___PR8F7::-webkit-scrollbar-track {
  display: none;
}
.EditStripsPopup-module__medical-table-new___PR8F7.EditStripsPopup-module__no-pagination___vcuk6 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.EditStripsPopup-module__medical-table-new___PR8F7.EditStripsPopup-module__no-pagination___vcuk6:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.EditStripsPopup-module__medical-table-new___PR8F7.EditStripsPopup-module__no-pagination___vcuk6::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.EditStripsPopup-module__medical-table-new___PR8F7.EditStripsPopup-module__no-pagination___vcuk6::-webkit-scrollbar-track {
  display: none;
}

.EditStripsPopup-module__medical-table-empty___VBhHk {
  padding: 14px 40px !important;
}

.EditStripsPopup-module__icon-btn____if3X {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.EditStripsPopup-module__search-icon___hHKaH {
  width: 24px;
  height: 24px;
  align-self: center;
}

.EditStripsPopup-module__disable-select___QQSDW {
  user-select: none;
}

.EditStripsPopup-module__break-word___mXYIO {
  word-break: break-word;
}

.EditStripsPopup-module__popup-clear-btn___E4T1X {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.EditStripsPopup-module__scroll-m-b-20___sc3ko {
  scroll-margin-bottom: 20px;
}

.EditStripsPopup-module__text___nBOq_ {
  padding: 20px 30px;
}

.EditStripsPopup-module__buttonsContainer___orNvU {
  display: flex;
  flex-direction: row;
  justify-content: end;
  padding: 19px 30px;
  gap: 16px;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/popups/EditStripsPopup/EditStripsPopup.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,SAAA;EACA,2CAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.text {\n  padding: 20px 30px;\n}\n\n.buttonsContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  padding: 19px 30px;\n  gap: 16px;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `EditStripsPopup-module__font-s-10___Y97R0`,
	"fontS12": `EditStripsPopup-module__font-s-12___fTesY`,
	"fontS13": `EditStripsPopup-module__font-s-13___cYsI0`,
	"fontS14": `EditStripsPopup-module__font-s-14___s1iqn`,
	"fontS15": `EditStripsPopup-module__font-s-15___L3_9m`,
	"fontS16": `EditStripsPopup-module__font-s-16___INQCu`,
	"fontS18": `EditStripsPopup-module__font-s-18___uM_R2`,
	"fontS20": `EditStripsPopup-module__font-s-20___xycTO`,
	"fontS22": `EditStripsPopup-module__font-s-22___fgh5A`,
	"fontS28": `EditStripsPopup-module__font-s-28___tFyKd`,
	"fontW400": `EditStripsPopup-module__font-w-400___GjqZ2`,
	"fontW500": `EditStripsPopup-module__font-w-500___N4f53`,
	"fontW600": `EditStripsPopup-module__font-w-600___jhCvM`,
	"fontW700": `EditStripsPopup-module__font-w-700___fkQJG`,
	"p5": `EditStripsPopup-module__p-5___kRdAx`,
	"p12": `EditStripsPopup-module__p-12___ifLzp`,
	"p16": `EditStripsPopup-module__p-16___PXM4V`,
	"p30": `EditStripsPopup-module__p-30___Mh0Ja`,
	"pB0": `EditStripsPopup-module__p-b-0___JvKTV`,
	"pB5": `EditStripsPopup-module__p-b-5___l4cf5`,
	"pB10": `EditStripsPopup-module__p-b-10___tz1Jb`,
	"pB12": `EditStripsPopup-module__p-b-12___uYhba`,
	"pB16": `EditStripsPopup-module__p-b-16___zeyHl`,
	"pB18": `EditStripsPopup-module__p-b-18___bmisQ`,
	"pB20": `EditStripsPopup-module__p-b-20___ZySWv`,
	"pB25": `EditStripsPopup-module__p-b-25___OmDyk`,
	"pB30": `EditStripsPopup-module__p-b-30___rKdhr`,
	"pB50": `EditStripsPopup-module__p-b-50___tC2WV`,
	"pT0": `EditStripsPopup-module__p-t-0___jqF19`,
	"pT12": `EditStripsPopup-module__p-t-12___auH_k`,
	"pT16": `EditStripsPopup-module__p-t-16___YV13i`,
	"pT18": `EditStripsPopup-module__p-t-18___ADhRx`,
	"pT20": `EditStripsPopup-module__p-t-20___aI2LY`,
	"pT30": `EditStripsPopup-module__p-t-30___GwXdG`,
	"pT40": `EditStripsPopup-module__p-t-40___qoWXb`,
	"pT50": `EditStripsPopup-module__p-t-50___aNVpX`,
	"pL20": `EditStripsPopup-module__p-l-20___Atvdm`,
	"pL30": `EditStripsPopup-module__p-l-30___YFOZK`,
	"pL40": `EditStripsPopup-module__p-l-40___xkjiO`,
	"pR16": `EditStripsPopup-module__p-r-16___cR4j5`,
	"pR20": `EditStripsPopup-module__p-r-20___b6dzT`,
	"pR30": `EditStripsPopup-module__p-r-30___CoZWk`,
	"pR50": `EditStripsPopup-module__p-r-50___als49`,
	"pR60": `EditStripsPopup-module__p-r-60___KQxMY`,
	"mB1": `EditStripsPopup-module__m-b-1___ljCrE`,
	"mB2": `EditStripsPopup-module__m-b-2___YO6wO`,
	"mB6": `EditStripsPopup-module__m-b-6___l1k0x`,
	"mB8": `EditStripsPopup-module__m-b-8___rMZrJ`,
	"mB10": `EditStripsPopup-module__m-b-10___tp_fV`,
	"mB14": `EditStripsPopup-module__m-b-14___dIg7K`,
	"mB16": `EditStripsPopup-module__m-b-16___sYzlc`,
	"mB20": `EditStripsPopup-module__m-b-20___xvS_S`,
	"mB22": `EditStripsPopup-module__m-b-22____LxBv`,
	"mB24": `EditStripsPopup-module__m-b-24___Fpvx4`,
	"mB30": `EditStripsPopup-module__m-b-30___WSk3j`,
	"mB32": `EditStripsPopup-module__m-b-32___rH9TZ`,
	"mB40": `EditStripsPopup-module__m-b-40___jLI84`,
	"mT2": `EditStripsPopup-module__m-t-2___IY4cC`,
	"mT3": `EditStripsPopup-module__m-t-3___zVIuH`,
	"mT4": `EditStripsPopup-module__m-t-4___djm1j`,
	"mT5": `EditStripsPopup-module__m-t-5___gjQfG`,
	"mT8": `EditStripsPopup-module__m-t-8___zfggq`,
	"mT10": `EditStripsPopup-module__m-t-10___DFlFN`,
	"mT15": `EditStripsPopup-module__m-t-15___lgT0J`,
	"mT16": `EditStripsPopup-module__m-t-16___S7daC`,
	"mT20": `EditStripsPopup-module__m-t-20___R1Gw6`,
	"mT22": `EditStripsPopup-module__m-t-22___HFLmg`,
	"mT30": `EditStripsPopup-module__m-t-30___irDCZ`,
	"mT32": `EditStripsPopup-module__m-t-32___kHxJM`,
	"mLAuto": `EditStripsPopup-module__m-l-auto___QldPu`,
	"mL4": `EditStripsPopup-module__m-l-4____ogOk`,
	"mL5": `EditStripsPopup-module__m-l-5___y5yJd`,
	"mL6": `EditStripsPopup-module__m-l-6___NUGzv`,
	"mL8": `EditStripsPopup-module__m-l-8___HTHPs`,
	"mL10": `EditStripsPopup-module__m-l-10___NEhvm`,
	"mL16": `EditStripsPopup-module__m-l-16____AUZI`,
	"mL20": `EditStripsPopup-module__m-l-20___QBauV`,
	"mL24": `EditStripsPopup-module__m-l-24___pwNqp`,
	"mL30": `EditStripsPopup-module__m-l-30___X9x7z`,
	"mL35": `EditStripsPopup-module__m-l-35___u8HKS`,
	"mL40": `EditStripsPopup-module__m-l-40___qXHUR`,
	"mR8": `EditStripsPopup-module__m-r-8___VBzBo`,
	"mR10": `EditStripsPopup-module__m-r-10___t4pMm`,
	"mR16": `EditStripsPopup-module__m-r-16____Obi1`,
	"mR20": `EditStripsPopup-module__m-r-20___rH2nP`,
	"mR24": `EditStripsPopup-module__m-r-24___BFrde`,
	"mR30": `EditStripsPopup-module__m-r-30___cspZ_`,
	"mR40": `EditStripsPopup-module__m-r-40___rGiZ_`,
	"borderR3": `EditStripsPopup-module__border-r-3___vJDHI`,
	"borderR4": `EditStripsPopup-module__border-r-4___S15eU`,
	"borderR6": `EditStripsPopup-module__border-r-6___kPX_D`,
	"borderR10": `EditStripsPopup-module__border-r-10___fZr10`,
	"borderR12": `EditStripsPopup-module__border-r-12___R8UOT`,
	"borderR16": `EditStripsPopup-module__border-r-16___BgwE7`,
	"borderR50": `EditStripsPopup-module__border-r-50___IkGyt`,
	"primaryBorder": `EditStripsPopup-module__primary-border___KgbgO`,
	"primaryBorderB": `EditStripsPopup-module__primary-border-b___VD5qv`,
	"primaryBorderT": `EditStripsPopup-module__primary-border-t___dbvMd`,
	"primaryBorderL": `EditStripsPopup-module__primary-border-l___YrJiR`,
	"primaryBorderR": `EditStripsPopup-module__primary-border-r___bdKpo`,
	"secondaryBorder": `EditStripsPopup-module__secondary-border___O6XcN`,
	"secondaryBorderB": `EditStripsPopup-module__secondary-border-b___zDGgv`,
	"secondaryBorderT": `EditStripsPopup-module__secondary-border-t___xcFoh`,
	"secondaryBorderL": `EditStripsPopup-module__secondary-border-l___COnH3`,
	"secondaryBorderR": `EditStripsPopup-module__secondary-border-r___HpCtD`,
	"gap0": `EditStripsPopup-module__gap-0___Dh4eT`,
	"gap2": `EditStripsPopup-module__gap-2___kFwR1`,
	"gap4": `EditStripsPopup-module__gap-4___thHmJ`,
	"gap5": `EditStripsPopup-module__gap-5___OC9j1`,
	"gap6": `EditStripsPopup-module__gap-6___qtNaa`,
	"gap8": `EditStripsPopup-module__gap-8___xQvfc`,
	"gap10": `EditStripsPopup-module__gap-10___dMjHj`,
	"gap12": `EditStripsPopup-module__gap-12___RTTXP`,
	"gap14": `EditStripsPopup-module__gap-14___MX9k3`,
	"gap16": `EditStripsPopup-module__gap-16___glDQR`,
	"gap18": `EditStripsPopup-module__gap-18___JNI_7`,
	"gap20": `EditStripsPopup-module__gap-20___tOt26`,
	"gap24": `EditStripsPopup-module__gap-24___WxA61`,
	"gap26": `EditStripsPopup-module__gap-26___jJBLX`,
	"gap30": `EditStripsPopup-module__gap-30___Vpb7i`,
	"gap32": `EditStripsPopup-module__gap-32___RWRva`,
	"gap40": `EditStripsPopup-module__gap-40___td9rT`,
	"gap50": `EditStripsPopup-module__gap-50___vhWk7`,
	"flex1": `EditStripsPopup-module__flex-1___WQajw`,
	"flexNone": `EditStripsPopup-module__flex-none___v4xVh`,
	"flexColumn": `EditStripsPopup-module__flex-column___yKwP0`,
	"flexRow": `EditStripsPopup-module__flex-row___qYKLD`,
	"verticallyCentered": `EditStripsPopup-module__vertically-centered___RtIDm`,
	"horizontallyCentered": `EditStripsPopup-module__horizontally-centered___vzWGI`,
	"horizontallyEnd": `EditStripsPopup-module__horizontally-end___SHI5d`,
	"verticallyStart": `EditStripsPopup-module__vertically-start___U4zYg`,
	"spaceBetween": `EditStripsPopup-module__space-between___Jq0f6`,
	"flexWrap": `EditStripsPopup-module__flex-wrap___tOEZc`,
	"height100": `EditStripsPopup-module__height-100___R5urd`,
	"width50": `EditStripsPopup-module__width-50___Iq30J`,
	"width100": `EditStripsPopup-module__width-100___C9qcb`,
	"cursorPointer": `EditStripsPopup-module__cursor-pointer___ey1iK`,
	"cursorNotAllowed": `EditStripsPopup-module__cursor-not-allowed___KRjl4`,
	"absoluteCentered": `EditStripsPopup-module__absolute-centered___su2P_`,
	"absolute": `EditStripsPopup-module__absolute___N2TRm`,
	"relative": `EditStripsPopup-module__relative___Tcp7z`,
	"fixed": `EditStripsPopup-module__fixed___ZTxsX`,
	"visible": `EditStripsPopup-module__visible___vc571`,
	"invisible": `EditStripsPopup-module__invisible___x2Pyb`,
	"col90": `EditStripsPopup-module__col-90___wGuMA`,
	"colAuto": `EditStripsPopup-module__col-auto___AcmjY`,
	"medicalTabs": `EditStripsPopup-module__medical-tabs___I8CNx`,
	"medicalTableNew": `EditStripsPopup-module__medical-table-new___PR8F7`,
	"noPagination": `EditStripsPopup-module__no-pagination___vcuk6`,
	"medicalTableEmpty": `EditStripsPopup-module__medical-table-empty___VBhHk`,
	"iconBtn": `EditStripsPopup-module__icon-btn____if3X`,
	"searchIcon": `EditStripsPopup-module__search-icon___hHKaH`,
	"disableSelect": `EditStripsPopup-module__disable-select___QQSDW`,
	"breakWord": `EditStripsPopup-module__break-word___mXYIO`,
	"popupClearBtn": `EditStripsPopup-module__popup-clear-btn___E4T1X`,
	"scrollMB20": `EditStripsPopup-module__scroll-m-b-20___sc3ko`,
	"text": `EditStripsPopup-module__text___nBOq_`,
	"buttonsContainer": `EditStripsPopup-module__buttonsContainer___orNvU`
};
module.exports = ___CSS_LOADER_EXPORT___;
